// extracted by mini-css-extract-plugin
module.exports = {"analyticsPage":"_2s4rsKe-"};